import { IApiError } from "../IApiError";

export default function isApiError(error: unknown): error is IApiError {
    if (
        typeof error === "object" &&
        error !== null &&
        "body" in error
    ) {
        const err = error as { body?: unknown };

        if (
            typeof err.body === "object" &&
            err.body !== null &&
            "statusCode" in err.body &&
            "message" in err.body
        ) {
            const body = err.body as { statusCode?: unknown; message?: unknown };

            return (
                typeof body.statusCode === "number" &&
                typeof body.message === "string"
            );
        }
    }

    return false;
}
